import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";
import {
  FETCH_ALL,
  FETCH,
  DISCARD_CHANGES,
  SAVE,
  LIMPAR_ACERVOS,
  DELETE
} from "@/store/actions/actions.type";

import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END,
  FETCH_START,
  SET,
  RESET,
  FETCH_END,
  DELETE_START,
  UNSET,
  DELETE_END,
  SAVE_START,
  SAVE_END
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  acervo: {
    id: undefined,
    fornecedor: {
      id: null
    },
    observacoes: "",
    valor_mensal: null,
    valor_acessos_excedentes: null,
    limite_acessos: null,
    deleted: false
  }
  // acervos: {
  //   current_page: 1,
  //   per_page: 10,
  //   data: []
  // }
});

const state = {
  acervo: object.clone(defaults.acervo),
  acervos: [],
  acervoOriginal: object.clone(defaults.acervo),
  isFetchingAcervos: false,
  isFetchingAcervo: false,
  isSavingAcervo: false,
  isDeletingAcervo: false,
  deletingId: null
};

const getters = {
  acervo(state) {
    return state.acervo;
  },
  acervos(state) {
    return state.acervos;
  },
  isFetchingAcervos(state) {
    return state.isFetchingAcervos;
  },
  isFetchingAcervo(state) {
    return state.isFetchingAcervo;
  },
  isSavingAcervo(state) {
    return state.isSavingAcervo;
  },
  isDeletingAcervo(state) {
    return state.isDeletingAcervo;
  },
  deletingId(state) {
    return state.deletingId;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiAdmin.query("acervos/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [FETCH](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SET, object.clone(defaults.acervo));

      if (!params) {
        resolve();
        return;
      }

      context.commit(FETCH_START);

      ApiAdmin.get("acervos/get", params)
        .then(response => {
          if (response.data.id) {
            context.commit(SET, response.data);
            resolve();
          } else {
            reject({ notFound: true });
          }
        })
        .catch(e => {
          console.log(e);
          reject(false);
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  },
  [DISCARD_CHANGES](context) {
    return new Promise(resolve => {
      context.commit(RESET);
      resolve();
    });
  },
  [SAVE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);
      ApiAdmin.post("acervos/manage", params)
        .then(response => {
          context.commit(SET, response.data);
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(SAVE_END);
        });
    });
  },
  [DELETE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(DELETE_START, params);
      ApiAdmin.delete("acervos/delete", params)
        .then(() => {
          context.commit(UNSET, params);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response);
        })
        .finally(() => {
          context.commit(DELETE_END);
        });
    });
  },
  [LIMPAR_ACERVOS](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(DELETE_START, params);
      ApiAdmin.post("acervos/limpar", params)
        .then(() => {
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response);
        });
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingAcervos = true;
  },
  [SET_ALL](state, acervos) {
    state.acervos = acervos;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingAcervos = false;
  },
  [FETCH_START](state) {
    state.isFetchingAcervo = true;
  },
  [SET](state, acervo) {
    state.acervo = acervo;
    state.AcervoOriginal = object.clone(acervo);
  },
  [RESET](state) {
    state.acervo = object.clone(state.AcervoOriginal);
  },
  [FETCH_END](state) {
    state.isFetchingAcervo = false;
  },
  [DELETE_START](state, AcervoId) {
    state.deletingId = AcervoId;
    state.isDeletingAcervo = true;
  },
  [UNSET](state, id) {
    state.acervos.data = state.acervos.data.filter(item => {
      return item.id != id;
    });
  },
  [DELETE_END](state) {
    state.isDeletingAcervo = false;
    state.deletingId = null;
  },
  [SAVE_START](state) {
    state.isSavingAcervo = true;
  },
  [SAVE_END](state) {
    state.isSavingAcervo = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
